
import { Injectable } from '@angular/core';
import { Company } from '../../interface/company/company';
import { HttpService } from '../http/http.service';
import { firstValueFrom } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  constructor(private _httpService: HttpService) { }
  public getAll(): Promise<Company[]> {
    return firstValueFrom(this._httpService.get('/Companies'));
  }
  public get(id: number): Promise<Company> {
    return firstValueFrom(this._httpService.get('/Companies/' + id));
  }
  public add(data: Company): Promise<Company> {
    return firstValueFrom(this._httpService.post('/Companies', data));
  }
  public update(id: number, data: Company): Promise<Company> {
    return firstValueFrom(this._httpService.patch('/Companies/', id, data));
  }
  public async delete(id: number): Promise<Company> {
    return firstValueFrom(this._httpService.delete('/Companies/', id));
  }

}
